import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import {Avatar} from 'shared/components';

const InterviewInviteBookingActionEntry = observer(({entry, candidate}) => {
  return (
    <div className='flex gap-6 border-top p3'>
      <Avatar employee={candidate} size='sm'/>
      <div>
        <div className='flex items-center gap-2'>
          <div className='h3 medium'>
            <FormattedMessage id={`recruiting.hiring_funnel.interview_invite_actions.${entry.action}`}/>
          </div>
          <div className='h5 jumbo'>{entry.date}</div>
        </div>
        <div className='h5 jumbo'>{candidate.name}</div>
        <div className='pt2'>
          <div className='h3'>{entry.interviewInvite.scheduleName}</div>
          {entry.action === 'cancelled' && <div className='line-through'>{entry.previousEventStartsAtView}</div>}
          {entry.action === 'scheduled' && <div>{entry.eventStartsAtView}</div>}
        </div>
      </div>
    </div>
  );
});

export default InterviewInviteBookingActionEntry;
